import { useEffect } from 'react';
import amplitude from '../services/amplitude';

export const useAmplitudeSearchPlateNumberPageView = () => {
  useEffect(() => {
    amplitude.searchPlateNumberPageView();
  }, []);
};
